import { Component, Input } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

@Component({
  selector: "evrideo-ag-grid-evrideo-checked-icon-cell",
  templateUrl: "./ag-grid-evrideo-checked-icon-cell.component.html",
  styleUrl: "./ag-grid-evrideo-checked-icon-cell.component.scss",
})
export class AgGridEvrideoCheckedIconCellComponent
  implements ICellRendererAngularComp
{
  @Input() checked: boolean = false;
  @Input() loaded: boolean = false;

  agInit(params: ICellRendererParams): void {
    this.updateParams(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.updateParams(params);
    return true;
  }

  updateParams(params: any) {
    if (!params?.data) {
      return;
    }
    this.checked = params.isChecked;
    this.loaded = true;
  }
}
